import { render, staticRenderFns } from "./FormSpinbuttonSize.vue?vue&type=template&id=5f1fdf1c&"
import script from "./FormSpinbuttonSize.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports